define(function(require) {
		const Radio = require('backbone.radio');
		const GlobalConfigModel = require('civicsModels/global_configuration_model');
		const AccountModel = require('civicsModels/account_model');
		const IpsModel = require('civicsBase/ipsModel');
		const ViewBindingManager = require('civicsUtils/view_binding_manager');
		const Utils = require('civicsUtils/general_utilities');
		const AutoComplete = require('civicsUtils/autocomplete');
		const Logger = require('civicsUtils/application/logger');
		const version_manager = require('civicsUtils/version_manager');
		const featureToggleUtility = require('civicsUtils/featureToggleUtility');
		
	const RHYTHM_SESSION_ID = 'RHYTHM_SESSION_ID';
	var getErrorMessage = function(error) {
		var json = '';
		_.forEach(error, function(value, key) {
			if (_.isObject(value)) {
				json = json + getErrorMessage(value);
			} else {
				json = json + key + ': ' + value + '. ';
			}
		});
		return json;
	};

	/**
	 * Associates an error message element with a form field via aria-describedby.
	 * Ensures the error div has an id, then adds it to the field's aria-describedby
	 * (preserving any existing references like tooltips).
	 */
	var associateErrorWithField = function(formElement, formElementId, errordiv) {
		var errorDivId = errordiv.attr('id');
		var messageId;

		if(typeof errorDivId == 'undefined') {
			messageId = formElementId + '-helper-msg';
			errordiv.attr('id', messageId);
		} else {
			messageId = errorDivId;
		}

		var formElementDescribedBy = formElement.attr('aria-describedby');

		if(formElementDescribedBy && formElementDescribedBy.length > 0) {
			// add to aria-describedby if it isn't already there
			if(!formElementDescribedBy.split(' ').includes(messageId)){
				formElement.attr('aria-describedby', formElementDescribedBy + ' ' + messageId);
			}
		} else {
			formElement.attr('aria-describedby', messageId);
		}
	};

	/**
	 * Removes aria-invalid and cleans up aria-describedby references to an error
	 * message from all input/select/textarea elements within a field container.
	 */
	var cleanupAriaErrorAttributes = function($fieldContainer, errorMsgId) {
		var $inputs = $fieldContainer.find('input, select, textarea');
		$inputs.each(function() {
			var $input = $(this);
			$input.removeAttr('aria-invalid');
			if(errorMsgId) {
				var describedBy = $input.attr('aria-describedby');
				if(describedBy) {
					var ids = describedBy.split(' ').filter((id) => id !== errorMsgId);
					if(ids.length > 0) {
						$input.attr('aria-describedby', ids.join(' '));
					} else {
						$input.removeAttr('aria-describedby');
					}
				}
			}
		});
	};

	/**
	 * Builds a required-field error message with an appended correction suggestion.
	 * @param {string} labelText - The visible label of the field
	 * @param {string} verb - 'enter' for text/number inputs, 'select' for dropdowns/radios/checkboxes
	 * @returns {string} Combined error message e.g. "Organization Name is required. Please enter your organization name."
	 */
	var buildRequiredErrorWithSuggestion = function(labelText, verb) {
		labelText = labelText.trim();
		var requiredMsg = i18n.t('CIVICS.COMMON.SINGLE_FIELD_REQUIRED', { field: labelText });
		var suggestionKey = verb === 'select'
			? 'CIVICS.COMMON.SINGLE_FIELD_REQUIRED_SELECT_SUGGESTION'
			: 'CIVICS.COMMON.SINGLE_FIELD_REQUIRED_ENTER_SUGGESTION';
		var suggestionMsg = i18n.t(suggestionKey, { field: labelText.toLowerCase() });
		return requiredMsg + ' ' + suggestionMsg;
	};

 // view can be marionette view or any jquery container object
	var showErrorMessage = function(error, view, options, parent, vm) {
		var container = view.$el ? view.$el : view;

		_.forEach(error.validationError, function(value, key) {
			var fieldName = key;
			var controlNameList = [];
			var childMoniker;
			var keyFlag = key.indexOf('.')>=0 && fieldName.includes('InforClient'); //keyflag is only used for custom validation
			//if the validation is meant for a grid, we have to handle it differently. Set a flag, fix the field name.
			var gridFlag = fieldName.indexOf('__grid__') === 0;
			fieldName = gridFlag ? fieldName.substring(8) : fieldName;

			if (keyFlag) {
				controlNameList = key.split(".");
				fieldName = controlNameList[controlNameList.length - 1];
				childMoniker = key.replace("." + fieldName,"");
			}

			if (parent && parent.length > 0) {
				fieldName = parent + "." + fieldName;
			}

			if (_.isObject(value)) {
				showErrorMessage(value, view, options, fieldName, vm);
			} else {

				if (options && options.prefix) {
					fieldName = options.prefix + '.' + fieldName;
				}
				var selector = "";
				if(!fieldName)fieldName='';
				if(options && options.byID){
					//we use the id attribute selector instead of #id here because the attribute selector will select multiples with the same ID this way.
					//this is necessary for Date Time fields, which share an ID. Unfortunately this means both date and time fields will be marked invalid if only one is invalid.
					//the alternative is the first one in the dom is invalid even if the second one might be the invalid one.
					selector = "[id='{0}']".format(fieldName);
				} else if (gridFlag){
					selector = "[data-gridBind='"+fieldName+"']";
				}else {
					selector = "[name='{0}']".format(fieldName);
				}

				var detailpagemoniker = "[data-detailpagemoniker='{0}']".format(childMoniker);

				if (keyFlag) selector = $(detailpagemoniker + ' ' + selector);

				if (container.find(selector).length > 0) {
					//need to loop through in case we have a date time field pair
					$.each(container.find(selector),function(index, el){
						var formElement = $(el);
						formElement.attr('aria-invalid', 'true');
						var elementId = formElement.attr("id");

						//find error div inside same parent
						var errordiv = formElement.parents(".field").find('.helper-msg-container').last();

						if(errordiv.length == 0) {
							errordiv = formElement.parents(".field").find('.helper-msg').last();
						}

						if(errordiv.length == 0) {
							if(formElement.parents(".field").length > 0) {

								errordiv = $('<div/>',{
									'class': 'helper-msg'
								});

								formElement.parents(".field").append(errordiv);

							} else if(gridFlag) {
								//if we're in a grid error situation, the selector is the grid wrapper.
								errordiv = $('<div/>',{
									'class': 'helper-msg'
								});

								formElement.find('.grid-title').after(errordiv);
								formElement.addClass('error');
							}
						}

						var errorId = errordiv.attr("id");

						if (errordiv.length > 0) {

							// Create new error html
							let newError = $('<div class="error-message"></div>');

							if(!errordiv.hasClass("helper-msg-container")) {
								newError = $('<div class="helper-msg-container" id="' + elementId + '-helper-msg"><div class="error-message"></div></div>');
							} else {
								//this is for the non partial helper-msg-container
								if(errordiv.css('display') == 'none') {
									errordiv.show();
								}
							}

							// Get current error div information
							var children = errordiv.children();
							errordiv.empty();
							if (selector !== "[name='notification_msg']") {
								errordiv.parents(".field").addClass('error');
								errordiv.parent().show();
								errordiv.append(children);
							} else if(gridFlag){
								formElement.addClass('error');
							}else {
								errordiv.append(children[2]);
							}

							// Add new error markup and clear previous
							if(!errordiv.hasClass("helper-msg-container")) {
								errordiv.after(newError);
								errordiv.remove();

								if(value != null && value.length > 0) {
									newError.find(".error-message").addBack(".error-message").append(Utils.outputErrorMessage(vm.htmlSafeString(value)));
								}
							} else {
								errordiv.empty();
								if(value != null && value.length > 0) {
									errordiv.append(newError);
									newError.find(".error-message").addBack(".error-message").append(Utils.outputErrorMessage(vm.htmlSafeString(value)));
								}
							}

							// add an id to the error message (if it doesn't already exist).
							// associate that error message with the input field by setting aria-describedby = error message id on the form element
							// If the form element has no id, generate one so aria-describedby can be established
							var formElementId = formElement.attr('id');
							if(!formElementId) {
								formElementId = 'field-' + fieldName.replace(/\./g, '-') + '-' + index;
								formElement.attr('id', formElementId);
							}

							associateErrorWithField(formElement, formElementId, errordiv);

						} else {
							//This control does not have an error div.  Just output a message for now.
							vm.openAlert(value);
						}

					});
				}
				else {
					vm.openAlert(value, error.isCustomValidation);
				}
			}
		});
		//find element with error
	};

	return {
		validatePageControl: function(view, byID) {
		  byID = (byID === true);
		  var self = this;
		  var valid = true;
		  var target;
		  if (view.$el) {
		    target = view.$el;
		  } else {
		    target = $(view);
		  }
		  if (target) {
		    //select non-grid inputs.
		    var inputs = target.find(':input'); //.not('[specialtype="grid"]');
		    var validationError = {};

		    var processed = [];
		    var radios = inputs.filter(function(index) {
		      return $(this).attr('type') == 'radio'
		    })
		    _.forEach(radios, radio => {
		      if (radio.name && !radio.disabled && radio.required) {
		        //process it only Once
		        if (_.select(processed, x => x == radio.name).length == 0) {
		          processed.push(radio.name);
		          var radioSet = radios.filter(function(index) {
		            return $(this).attr('name') == radio.name
		          });
		          // if none of the input in the radio is set, display an error
		          if (!$(radioSet).is(':checked')) {
								var label = target.find('label[for="' + radio.id + '"]');

								// If the field is a radio button group, look for the legend instead of the label
								var fieldset = label.parents('.radiobutton-container');
								if(fieldset.length) {
			            label = fieldset.find('legend').first();
								}

		            if (label && label.length > 0) {
		              var labelText = label.contents().filter(function() {
		                return this.nodeType == 3;
		              })[0].nodeValue;

									// Sometimes the label or legend is filled with HTML elements that will make the error message appear empty
									if (labelText.trim().length <= 0) {
										let stringbuilder;
										let stringselector = label.clone();

										stringselector.find("em.required").remove();
										stringselector.find("ul").remove();

										labelText = stringselector.text();
									}

		              validationError[byID ? radio.id : radio.name] = buildRequiredErrorWithSuggestion(labelText, 'select');
		            } else {
		              validationError[radio.name] = i18n.t('CIVICS.COMMON.SELECTION_REQ_ERROR');
		            }
		          }
		        }
		      }
		    });

		    var texts = inputs.filter(function(index) {
		      return $(this).attr('type') == 'text'
		    })
			_.forEach(texts, text => {
				if (text.required &&  !text.disabled && $(text).val().trim() == '') {
					var label = target.find('label[for="' + text.id + '"]');

					// If the field is a checkbox group, look for the legend instead of the label
					var fieldset = label.parents('.checkbox-container');
					if (fieldset.length) {
						label = fieldset.find('legend').first();
					}

					if (label && label.length > 0) {
						var labelText = label.contents().filter(function () {
							return this.nodeType == 3;
						})[0].nodeValue;

						// Sometimes the label or legend is filled with HTML elements that will make the error message appear empty
						if (labelText.trim().length <= 0) {
							let stringbuilder;
							let stringselector = label.clone();

							stringselector.find("em.required").remove();
							stringselector.find("ul").remove();

							labelText = stringselector.text();
						}

						validationError[byID ? text.id : text.name] = buildRequiredErrorWithSuggestion(labelText, 'enter');
					} else {
						validationError[byID ? text.id : text.name] = i18n.t('CIVICS.COMMON.VALUE_REQ_ERROR');
					}

				}

				//added this for droppy input text
				if (text.required &&  !text.disabled && $(text).hasClass("droppy-input")) {
					var droppyVal = Utils.civicsDropdownValue($(text));
					if (_.isEmpty(droppyVal) || droppyVal.trim() == '') {
						var label = target.find('label[for="' + text.id + '"]');

						if (label && label.length > 0) {
							var labelText = label.contents().filter(function () {
								return this.nodeType == 3;
							})[0].nodeValue;

							validationError[byID ? text.id : text.name] = buildRequiredErrorWithSuggestion(labelText, 'select');
						} else {
							validationError[byID ? text.id : text.name] = i18n.t('CIVICS.COMMON.VALUE_REQ_ERROR');
						}
					}
				}
				//the new date picker partial uses a field set for date time fields, which is different than for date or time fields. It also doesn't have an actual label element.
				//so we have to approach them a bit differently.
				if (text.required &&  !text.disabled && $(text).hasClass("datepicker")) {
					if (_.isEmpty(text.value)){
						var label = $(text).closest('.input-date-fieldset').find('.input-label');
						if (label && label.length > 0) {
							var labelText = label.contents().filter(function () {
								return this.nodeType == 3;
							})[0].nodeValue;

							validationError[byID ? text.id : text.name] = buildRequiredErrorWithSuggestion(labelText, 'enter');
						}
					}
				}
			});

			var numbers = inputs.filter(function (index) {
				  return $(this).attr('type') == 'number'
			});
			_.forEach(numbers, number => {
				var $num = $(number);
				var valStr = $num.val().trim();
				//Number() will convert null or '' to 0. we don't want that.
				var val = valStr != '' && valStr != undefined ? Number(valStr) : null;


				if (number.required && !number.disabled && (valStr == '' || valStr =='0')) {
					var label = target.find('label[for="' + number.id + '"]');
					if (label && label.length > 0) {
						var labelText = label.contents().filter(function () {
							return this.nodeType == 3;
						})[0].nodeValue;
						if(valStr =='0'){
							validationError[byID ? number.id : number.name] = i18n.t('CIVICS.COMMON.ZERO_VALUE_ERROR', { field: labelText });
						} else {
						validationError[byID ? number.id : number.name] = buildRequiredErrorWithSuggestion(labelText, 'enter');
						}
					} else {
						validationError[byID ? number.id : number.name] = i18n.t('CIVICS.COMMON.VALUE_REQ_ERROR');
					}
				} else if (val != null) {//give required validation priority so error messages don't get overwritten. Otherwise, if we have a value, check for min/max
					var minVal, maxVal = null;
					var hasError = false;
					var errorMsg = null;
					if ($num.data('minval') != undefined){
						minVal = $num.data('minval');
						if ($num.data('minval') > val) {
							hasError = true;
						}
					}
					if ($num.data('maxval') != undefined) {
						maxVal = $num.data('maxval');
						if ($num.data('maxval') < val) {
							hasError = true;
						}
					}

					if (hasError) {
						if (minVal != null && maxVal != null) {
							errorMsg = i18n.t('CIVICS.COMMON.AMOUNT_BETWEEN_ERROR', { minVal: minVal, maxVal: maxVal });
						} else if (minVal != null) {
							errorMsg = i18n.t('CIVICS.COMMON.AMOUNT_GREATER_THAN_ERROR', { minVal: minVal });
						} else if (maxVal != null) {
							errorMsg = i18n.t('CIVICS.COMMON.AMOUNT_LESS_THAN_ERROR', { maxVal: maxVal });
						}

						validationError[byID ? number.id : number.name] = errorMsg;
					}

				}
			});

		    var selects = inputs.filter('select');
		    _.forEach(selects, select => {
		      if (select.required && !select.disabled && $(select).val().trim() == '') {

		        var label = target.find('label[for="' + select.id + '"]');

		        if (label && label.length > 0) {
		          var labelText = label.contents().filter(function() {
		            return this.nodeType == 3;
		          })[0].nodeValue;

		          validationError[byID ? select.id : select.name] = buildRequiredErrorWithSuggestion(labelText, 'select');
		        } else {
		          validationError[byID ? select.id : select.name] = i18n.t('CIVICS.COMMON.VALUE_REQ_ERROR');
		        }
		      }
		    });

		    var textAreas = inputs.filter('textarea');
		    _.forEach(textAreas, ta => {
		      if (ta.required && !ta.disabled && $(ta).val().trim() == '') {
		        var label = target.find('label[for="' + ta.id + '"]');

		        if (label && label.length > 0) {
		          var labelText = label.contents().filter(function() {
		            return this.nodeType == 3;
		          })[0].nodeValue;

		          validationError[byID ? ta.id : ta.name] = buildRequiredErrorWithSuggestion(labelText, 'enter');
		        } else {
		          validationError[byID ? ta.id : ta.name] = i18n.t('CIVICS.COMMON.VALUE_REQ_ERROR');
		        }

		      }
		    });

		    var checkboxes = inputs.filter('[type=checkbox]');
		    _.forEach(checkboxes, cbox => {
		      if (cbox.required && !cbox.disabled && !cbox.checked) {
		        var label = target.find('label[for="' + cbox.id + '"]');

						// If the field is a checkbox group, look for the legend instead of the label
						var fieldset = label.parents('.checkbox-container');
						if(fieldset.length && label.parents('.detail-container').length == 0) {
							label = fieldset.find('legend').first();
						}

						if (label && label.length > 0) {
							var labelText = label.contents().filter(function() {
								return this.nodeType == 3;
							})[0].nodeValue;

							// Sometimes the label or legend is filled with HTML elements that will make the error message appear empty
							if (labelText.trim().length <= 0) {
								let stringbuilder;
								let stringselector = label.clone();

								stringselector.find("em.required").remove();
								stringselector.find("ul").remove();

								labelText = stringselector.text();
							}

							validationError[byID ? cbox.id : cbox.name] = buildRequiredErrorWithSuggestion(labelText, 'select');
						} else {
							validationError[byID ? cbox.id : cbox.name] = i18n.t('CIVICS.COMMON.CHECKBOX_REQ_ERROR');
		        }
		      }
		    });

		    for (var prop in validationError) {
		      valid = false;
		      break;
		    }
		    if (!valid) {
		      this.errorToWindow({
		        validationError: validationError
		      }, view, {
		        byID: byID
		      });
		      if (!self.scrollValidatePC) {
		        self.scrollValidatePC = setTimeout(function() {
		          self.scrollToError({
		            validationError: validationError
		          }, view, {
		            byID: byID
		          });
		          self.focusError(view);
		          clearTimeout(self.scrollValidatePC);
		          self.scrollValidatePC = undefined;
		        }, 300);
		      }
		    }
		  }

			return valid;
	},
	/**
	 * Display validation or server errors to the user
	 * 
	 * ERROR OBJECT STRUCTURE:
	 * 
	 * For validation errors (inline field errors or alert):
	 * {
	 *   validationError: {
	 *     fieldName: "Error message",           // Single field error
	 *     anotherField: "Another error",        // Multiple fields
	 *     "nested.field": "Nested error",       // Nested object notation
	 *     "__grid__gridName": "Grid error"      // Grid-specific error (prefix with __grid__)
	 *   }
	 * }
	 * 
	 * For server/AJAX errors (from jQuery AJAX failure):
	 * {
	 *   status: 404,                            // HTTP status code
	 *   responseJSON: {                         // Optional: parsed JSON response
	 *     responseStatus: {
	 *       message: "Error details"
	 *     },
	 *     message: "Alternative error message"
	 *   },
	 *   responseText: "Raw error text"          // Optional: raw response text
	 * }
	 * 
	 * USAGE EXAMPLES:
	 * 
	 * 1. Single field validation error with view (inline):
	 *    ViewManager.errorToWindow({ 
	 *      validationError: { username: "Username is required" } 
	 *    }, this);
	 * 
	 * 2. Multiple field errors with view (inline):
	 *    ViewManager.errorToWindow({ 
	 *      validationError: { 
	 *        email: "Email is invalid",
	 *        password: "Password must be 8+ characters"
	 *      } 
	 *    }, this);
	 * 
	 * 3. Field error without view (shows alert dialog):
	 *    ViewManager.errorToWindow({ 
	 *      validationError: { general: "Something went wrong" } 
	 *    });
	 * 
	 * 4. Grid error (prefix field name with __grid__):
	 *    ViewManager.errorToWindow({ 
	 *      validationError: { "__grid__myGrid": "At least one row required" } 
	 *    }, this);
	 * 
	 * 5. Custom HTML error message (not escaped):
	 *    ViewManager.errorToWindow({ 
	 *      validationError: { field: "Error with <strong>HTML</strong>" } 
	 *    }, this, { isCustomValidation: true });
	 * 
	 * 6. Use field ID instead of name attribute:
	 *    ViewManager.errorToWindow({ 
	 *      validationError: { myFieldId: "Error message" } 
	 *    }, this, { byID: true });
	 * 
	 * 7. AJAX error (pass jqXHR directly):
	 *    model.save(null, {
	 *      error: (model, response) => {
	 *        ViewManager.errorToWindow(response);
	 *      }
	 *    });
	 * 
	 * 8. Custom error message as alert - use openAlert instead:
	 *    ViewManager.this.openAlert("Message here");
	 * 
	 * @param {Object} error - Error object (see structure above)
	 * @param {Object} view - Marionette view or jQuery element (optional, omit for alert)
	 * @param {Object} options - { isCustomValidation: boolean, byID: boolean, prefix: string } (optional)
	 */
	errorToWindow: function(error, view, options) {
			var isCustomValidation = options && options.isCustomValidation;
			var skipFocus = (options && options.skipFocus) === true;

			if (error.validationError) {
				if (view) {
					if(isCustomValidation) {
						error.isCustomValidation = true;
					}
					showErrorMessage(error, view, options, '', this);
					if(!skipFocus) {
						this.focusError(view);
					}
				} else {
					//no view found
					this.openAlert(getErrorMessage(error.validationError), isCustomValidation);
				}
			} else {
// OPTIMIZE:
				var message;
				var statusErrorMap = {
					'400': i18n.t('CIVICS.COMMON.SERVER_ERRORS.400'),
					'401': i18n.t('CIVICS.COMMON.SERVER_ERRORS.401'),
					'403': i18n.t('CIVICS.COMMON.SERVER_ERRORS.403'),
					'404': i18n.t('CIVICS.COMMON.SERVER_ERRORS.404'),
					'409': i18n.t('CIVICS.COMMON.SERVER_ERRORS.409'),
					'500': i18n.t('CIVICS.COMMON.SERVER_ERRORS.500'),
					'503': i18n.t('CIVICS.COMMON.SERVER_ERRORS.503'),
					'423': i18n.t('CIVICS.COMMON.SERVER_ERRORS.MAINT_MODE')

					// '400': "Server understood the request, but request content was invalid.",
					// '401': "Unauthorized access.",
					// '403': "Forbidden resource can't be accessed.",
					// '404': "Resource not found.",
					// '409': "Request could not be completed due to invalid data state.",
					// '500': "Internal server error.",
					// '503': "Service unavailable."
					// '423': "Application is currently in Maintenance Mode."
				};
				if (error.status) {
					if (error.status === 0) {
						console.log("request is cancelled or denied.");
					} else {
						message = statusErrorMap[error.status];

						if (error.responseJSON) {
							if (error.responseJSON.responseStatus)
								message = message + error.responseJSON.responseStatus.message;
							else if (error.responseJSON.message)
								message = message + error.responseJSON.message;
						} else if (error.responseText) {
							message = message + error.responseText;
						}
						if (!message) {
							message = "Unknown Error: " + error.status;
						}
					}
				} else if (error.responseJSON && error.responseJSON.responseStatus) {
					message = error.responseJSON.responseStatus.message;
				}
				this.logError("ErrorToWindow: " + error.status + " - " + message);

				//THE WRAPPING IF/ELSE IS TEMPORARY - remove after fixing the liferay API 404 redirect.
				if(error.status == 404 && message){
					this.openAlert('404 Not Found Error')
				} else {
					if (message) this.openAlert(message,isCustomValidation);
				}
			}
		},
		navigatorShare: function(title, url, fallbackCallback) {
			if (this._shareInProgress) {
				return;
			}
			var shareData = {
				title: title,
				url: url
			};
			this._shareInProgress = true;
			navigator.share(shareData)
				.catch(function(err) {
					if (err.name !== 'AbortError' && fallbackCallback) {
						fallbackCallback();
					}
				})
				.then(function() {
					this._shareInProgress = false;
				}.bind(this));
		},
		focusError: function(view) {
			// assuming errors are already on the page

			var container = view.$el ? view.$el: view;

			var errors = container.find('.field.error input, .field.error select, .field.error textarea');

			if(errors.length > 0) {
				var firstError = errors.first();

				firstError.focus();
			}

		},
		scrollToError: function(error, view, options) {
			var scrollTop;
			var alertsWrapper = $('.alerts-wrapper');
			var fixedHeader = $('.fixed-header').length == 1 && $('.fixed-header').is(':visible') ? $('.fixed-header').outerHeight() : 0;
			if (alertsWrapper.length > 0) {
				scrollTop = alertsWrapper.offset().top - fixedHeader;
				if(scrollTop){
					$([document.documentElement, document.body]).animate({
						scrollTop: scrollTop
					},{
						duration: 500,
						complete: () => {
							this.focusError(view);
						}
					});
				}
				return false;
			}

			if (error.validationError) {
				var container = view.$el ? view.$el: view;
				var validationError = error.validationError;
				var getFieldName = function(value, key) {
					if (_.isObject(value)) {
						key = getFieldName(_.values(value)[0], key + '.' + _.keys(value)[0]);

						if(key.indexOf('.validationError'))
						{
							key = key.replace('.validationError','');
						}
					}
					return key;
				};
				if (view) {
					_.forEach(validationError, function(value, key) {
						var fieldName = getFieldName(value, key);
						var selector = "";
						if (options && options.prefix) {
							fieldName = options.prefix + '.' + key;
						}
						if (options && options.byID) {
							selector = "[id='{0}']".format(fieldName);
						} else {
							selector = "[name='{0}']".format(fieldName);
						}

						var $selectors = $(container.find(selector));

						if ($selectors.length > 0) {
							//we need to find the parent with the .field class, as date fields are nested several divs deep from this field div.
							//Without this, the screen will scroll to the input, not the label as it should.
							var $parentField = $selectors.parents('.field');
							if($parentField.length>0){
								if (!(container.offsetParent().hasClass('bbm-modal--open') || container.offsetParent().find('.bbm-modal--open').length > 0)) {
									var elementTop = $parentField.offset().top;
									if(scrollTop == undefined || scrollTop > elementTop){
										scrollTop = elementTop;
									}
								} else {
									var containerModal = $(container.offsetParent().parent());
									var elementTop = $parentField.offset().top - containerModal.offset().top + containerModal.scrollTop();
									if(scrollTop == undefined || scrollTop > elementTop){
										scrollTop = elementTop;
									}
								}
							}
						}
					});

					if(scrollTop){
						if (!(container.offsetParent().hasClass('bbm-modal--open') || container.offsetParent().find('.bbm-modal--open').length > 0)) {
							$([document.documentElement, document.body]).animate({
								scrollTop: scrollTop-fixedHeader
							}, 500);
						} else {
							var containerModal = $(container.offsetParent().parent());
							containerModal.animate({
								scrollTop: scrollTop-fixedHeader
							}, 500);
						}
					}

				}
			} else {
				$(window).scrollTop();
			}
		},
        scrollTo: function(isScrollTop, position = 0, duration = 500){
            if(isScrollTop){
                $([document.documentElement, document.body]).animate({
                    scrollTop: position
                  }, duration);
            }else{
                $([document.documentElement, document.body]).animate({
                    scrollDown: position
                  }, duration);
            }
        },
		openAlert: function(message, isCustomValidation = false) {
			// Values of alert will be set in this variable
			// Complete will set focus to the alert 
			let getFocusOfAlert = 
			{
				duration: 'fast',
				complete: function() {
					$(".alerts-wrapper").first().get(0).focus();
				}
			}			
			var origMessage = message;
			if (!isCustomValidation){
				message = Handlebars.escapeExpression(message);
			}else {
				message = Handlebars.helpers['global:html'](message);
			}
			//Handlebars.helpers['global:html'] returns {string:'message text here'}
			//$.html() will pull the text out of this object, but in the case where we display message directly, nothing is displayed.
			//so we pull the string out and assign it to message, as intended. This specifically happens if myAlert doesn't exist below.
			if(message.string){
				message = message.string;
			}

			//TODO:  When we update the platform theme, I would like to be able to use the new notifications for informational messages as well.

			//This will open a page level alert.
			//The message will be appended if the alert is already open
			var myAlert = $('div.rhy>div.alerts-wrapper>div.content>div');
			if (myAlert.length == 0) {
				myAlert = $('<div>').addClass('rhy')
					.append($('<div>').addClass('alerts-wrapper')
					.attr('role','alert').attr("tabindex", 0)
						.append($('<header>')
							.append('<svg class="icon alert" aria-hidden="true"><use xlink:href="#alert"></use></svg>')
							.append($('<span>').addClass('alert-title').html('Error')))
							.append($('<div>').addClass('content')
								.append($('<div>').html(message))
							));

				var modal = null;
				var useModal = false;
				if( $('.bbm-container').length > 0 ){
					var modal = $('.bbm-container').parent();
					if( modal.parents('.remodal-is-closing, .remodal-is-closed').length == 0 ) {
						useModal = true;
					}
				}

				if (!__DEV__) {
					myAlert.addClass('container-controlled-padded');

					if( useModal ){
						if(modal.length <= 0) {
							modal = $('.bbm-container');
						}
						myAlert.prependTo(modal);
					}
					else{
						myAlert.prependTo('main.content');
					}
				} else {
					if( useModal ){
						if(modal.length <= 0) {
							modal = $('.bbm-container');
						}
						myAlert.prependTo(modal);
					}
					else {
						myAlert.css('padding-top', '28px');
						myAlert.prependTo('body');
					}
				}

				if( useModal ){
					if(!__DEV__){
						$('.rhythm-modals').animate({
							scrollTop: '0px'
						}, getFocusOfAlert );
					} else {
						$('.remodal-wrapper').animate({
							scrollTop: '0px'
						}, getFocusOfAlert);
					}
				}else{
					$('html, body').animate({
						scrollTop: myAlert.offset().top + 'px'
					}, getFocusOfAlert);
				}

			} else {//myAlert is already on the page
				if(myAlert.text().indexOf(message) < 0 && myAlert.text().indexOf(origMessage) < 0){
					myAlert.html(myAlert.html()+'</br>'+message);
				}
				if( $('.bbm-container').length > 0 ){
					$('.remodal-wrapper').animate({
						scrollTop: '0px'
					}, getFocusOfAlert);
				}else{
					$('html, body').animate({
						scrollTop: myAlert.offset().top + 'px'
					}, getFocusOfAlert);
				}
			}
			//trip falses force the loading overlay to go away.
			this.loading(false, false, false);

		},
		resetErrorMessages: function(view, skipWindowLevelErrorResetting = false) {
			//Remove any error messages on controls
			let errors = view.$el.find('.error .helper-msg, .error .helper-msg-container');

			errors.each(function(index, el) {
				var $parent = $(el).parents(".field");
				if($parent.length >0 ){//found field
					$(el).parents(".field").removeClass('error');

					// Clean up aria-invalid and aria-describedby on the form element
					cleanupAriaErrorAttributes($parent, $(el).attr('id'));

					// Only remove the error-message, not the whole field helper message area which may be used by other directions
					$parent.find(".error-message").remove();
				} else {
					let $grid = $(el).parents('.grid-wrapper');
					$grid.removeClass('.error');
					$grid.find('.error-message').remove();
				}
				
			});
			if(skipWindowLevelErrorResetting!==true){
				//Check parent elements of .alerts-wrapper before removing
				let civicsAlertsWrapper = $('.alerts-wrapper');
				
				civicsAlertsWrapper.each(function () {
					let isLiferayAlerts = $(this).parents('#portlet_com_liferay_announcements_web_portlet_AlertsPortlet').length > 0;

					if (!isLiferayAlerts) {
						$(this).remove();
					}
				})
			}
		},
		fromWindow: function(view) {
			Utils.updateSyphon();
			var rootData = Backbone.Syphon.serialize(view);
			//now process grid data
			// if this is a marionette view
			if ( view.$el ) {
				var tables = view.$el.find('table');
				if (tables.length > 0) {
					_.forEach(tables, table => {
						$(table).tableAccept();
						tableColls = $(table).data('data');
						var bind = $(table).attr('name');
						if (bind) {
							rootData[bind] = tableColls;
						}
					});
				}
			}
			return rootData;
		},
		toWindow: function(view, data) {
			ViewBindingManager.bindView(view, data);
		},
		versionRange: function(loVersion, hiVersion) {
			return version_manager.versionRange(loVersion, hiVersion);
		},
		versionCompare: function(versionToCompare) {
			version_manager.versionCompare(versionToCompare);
		},
		globalConfig: function(globalConfigPromise) {
			//Lets just load the version here so we only have to do it once.
			//setting as decimal
            var now = new Date();

			if( !this.globalConfigModel ){
				this.globalConfigModel = new GlobalConfigModel();
			}
			let gcAlreadyLoaded = this.isGCAlreadyLoaded();
			if(!gcAlreadyLoaded){
				this.globalConfigModel.fetch({ async: false, success: (response, status, xhrResponse)=> { 
					if (__DEV__) console.log("fetch success") 
					let responseData = response ? response.toJSON() : {};
                    if (typeof responseData !== 'undefined') {
                       this.setDefaultConfigData(responseData);
                    }
					var expDate = now.getTime() + 86400000; //180000;    //1 week         //86400000;   //one day
					App.sessionStorage.set( 'CIVICS', 'GLOBAL_CONFIG', JSON.stringify(responseData));
					App.sessionStorage.set( 'CIVICS', 'GLOBAL_CONFIG_EXPIRE', expDate);
				} });
				let currentRhythmSessionID = Utils.getCookie('RhythmSessionId');
				//store the current session ID for later comparison
				App.sessionStorage.set('CIVICS', RHYTHM_SESSION_ID, currentRhythmSessionID);

				//Clear the user specific session storage items
				this.clearUserSpecificSessionStorage();
				this.populateIpsVersion(this.globalConfigModel);
				this.setLocalCacheSettings(this.globalConfigModel);
				if(globalConfigPromise)
					globalConfigPromise.resolve(this.globalConfigModel);
			}else{
				this.globalConfigModel = new GlobalConfigModel(JSON.parse(App.sessionStorage.get('CIVICS', 'GLOBAL_CONFIG')));
				this.populateIpsVersion(this.globalConfigModel);
				this.setLocalCacheSettings(this.globalConfigModel);
				if(globalConfigPromise)
					globalConfigPromise.resolve(this.globalConfigModel);

				if(this.globalConfigModel.get('featureToggles'))
					featureToggleUtility.processGlobalConfigFeatureToggles(this.globalConfigModel.get('featureToggles').toJSON());
			}

			return this.globalConfigModel;
			//to use:
			//const ViewManager = require('civicsUtils/view_manager');    //initialize
			//this.globalConfig = ViewManager.globalConfig();             //fetch
			//this.globalConfig.get('titles.instrument');            //reference value
		},
		isGCAlreadyLoaded: function(){
            var now = new Date();
			let gcAlreadyLoaded = false;
			let gcString = App.sessionStorage.get('CIVICS', 'GLOBAL_CONFIG');
			let isGcValid = App.sessionStorage.get('CIVICS', 'GLOBAL_CONFIG_EXPIRE') != null && App.sessionStorage.get('CIVICS', 'GLOBAL_CONFIG_EXPIRE') > now.getTime();
			if (gcString == '' || gcString == null) {
				console.warn('Session Storage not found');
			}
			let storedRhythmSessionID = App.sessionStorage.get('CIVICS', RHYTHM_SESSION_ID );
			let currentRhythmSessionID = Utils.getCookie('RhythmSessionId');
			//if the rhtyhmSessionId changed, then the rhythm  session either expired, the browser closed, or the user logged out.
			//in this case, we would want to reload the global config, and clear any session values that might be sensitive.
			//otherwise, use the existing session globalConfig.
			return storedRhythmSessionID == currentRhythmSessionID && gcString != null && isGcValid;
		},
		populateIpsVersion:function(globalConfigModel){
			var myVersion = 0.0;
			// The server must use the following versioning format [major].[minor].[release].[build] format
			// when service return 8.5.0.1701, myVersionArray will move the numbers into an array
			var myVersionArray = [];
			var versionString = globalConfigModel.get('ipsVersion');
			if( versionString != null && typeof versionString == "string") {
				var versionSplit = versionString.split('.');
				var versionUnitCount = 4;
				//make sure it has 4 splits to generate the version number correctly
				var needToAppend = versionUnitCount - versionSplit.length;
				if ( needToAppend < 0 || needToAppend > 4){needToAppend = versionUnitCount;}
				for (var i = 0; i < needToAppend; i++) {
					versionSplit[versionUnitCount - needToAppend + i] = 0;
				}
				// old code that doesn't support minor verions more than 1 digit
				myVersion = +(parseInt(versionSplit[0])+'.'+parseInt(versionSplit[1]));
				for (var y = 0; y < versionUnitCount; y++) {
					myVersionArray[y] = parseInt(versionSplit[y]);
				}
			}
			globalConfigModel.set('ipsVersion', myVersion);
			globalConfigModel.set('ipsVersionArray', myVersionArray);
			App.currentIPSVersionArray = myVersionArray;
		},
		setDefaultConfigData: function(data){
			//Set defaults that may not be there if the agency has not updated Rest services (backward compatibility Yay!)
			if( data.usesCapacity == null ) data.usesCapacity = 'Hide';
			if( data.usesApplicantType == null ) data.usesApplicantType = 'Show';
			if( data.requireSecurityQuestion == null ) data.requireSecurityQuestion = true;
			if( data.reports.hideLinkWhenEmpty == null ) data.reports.hideLinkWhenEmpty = true;
			if( data.usesNotifications == null ) data.usesNotifications = 'Show';
			if( data.usesContactState == null ) {
				data.usesContactState = data.cultureInfo.includes('NZ') ? 'Hide' : 'Show';
			}
			if( data.ssoProvider == null ) data.ssoProvider = 'None';
			if( data.inviteApplicant == null ) data.inviteApplicant = 'Hide';
			if( data.addApplicant == null ) data.addApplicant = 'Show';
			if( data.usesInspectionRequestDate == null ) data.usesInspectionRequestDate = 'Show';
			if (data.allowForgotUsername == null) data.AllowForgotUsername = false;
			if (data.fees == null) data.fees = {};//set up the fees object just in case it doesn't exist. otherwise we have to check it several tiems in a row.
			if (data.fees.showFeeGroups == null) data.fees.showFeeGroups = false;
			if (data.fees.allowFeeGroupSelectionForPayment == null) data.fees.allowFeeGroupSelectionForPayment = false;
			if (data.fees.showIndividualFees == null) data.fees.showIndividualFees = true;
			if (data.fees.allowIndividualFeesSelectionForPayment == null) data.fees.allowIndividualFeesSelectionForPayment = true;
			if (data.loginRedirectPage == null) data.loginRedirectPage = {}; // set up login redirect object in case it doesn't exist
			if (data.loginRedirectPage.enabled == null) data.loginRedirectPage.enabled = false;
			if (data.organizationContactTypes == null) data.organizationContactTypes = [];
			if (data.featureToggles == null) data.featureToggles = {};
			if (data.featureToggles.inactiveFeatures == null) data.featureToggles.inactiveFeatures = [];

			//verify the config response sets the culture info, otherwise use the browser culture info, otherwise, en
			if( data.cultureInfo == null) data.cultureInfo = navigator.language || navigator.userLanguage || 'en';

            //NOTE: BILLING
            //NOTE:  Any values needed for billing services will need to be added here and to /civics-shared-bundle/src/api/services/portalConfigurationService.ts
            if (data.billing == null ) data.billing = { showPin: data.showPin, manageDirectDebit: true, enablePaperlessBilling: true, manageBillDelivery: true };
            if (data.registration == null) {
                data.registration = {};
            } 
            if (data.registration.billingRegister == null){
                data.registration.billingRegister = { useBirthDate: "Hide", useDriversLicense: "Hide", useEmailAddress: "Hide", useMobileNumber: "Hide", usePin: "Hide", useSSN: "Hide" };
            }
            if (data.billing.consumptionGraph == null) {
                data.billing.consumptionGraph = { displayByDay: false, displayByWeek: false, displayByMonth: true, displayByQuarter: false, displayByTrimester: false, displayByYear: false, defaultDisplay: "Month" };
            }
        },
        setLocalCacheSettings: function(globalConfigModel){
            App.localCacheSettings = {
                localCacheMaxNumOfResponse: globalConfigModel.get('localCacheMaxNumOfResponse'),
                localCacheMaxResponseSize: globalConfigModel.get('localCacheMaxResponseSize'),
                localCacheTTL: globalConfigModel.get('localCacheTTL'),
                isEnabled: globalConfigModel.get('localCacheEnabled') && this.versionRange('8.8.0.2310') && !App.sessionStorage.get('CIVICS', 'localCacheDisabled')
            }
        },
		currentUser: function(){
				//Currently we are only storing the Contact Key since that is the only thing used right now.
				if (!this.accountModel) {
				this.accountModel = new AccountModel();
				}

				var contact = new IpsModel();
				if(App.user.id != null){
					contact.set("id", App.user.id);
				} else {
					contact.set("id", this.accountModel.get('contactId.id'));
				}
				this.accountModel.set("contactId", contact);

				return this.accountModel;
		},
		isServiceProvider: function(){
			if( App.user.isServiceProvider == null )
				return false;
			else if( App.user.isServiceProvider == true )
				return true;
			else
				return false;
		},
		setMapState: function(namespace, key, state){
				App.localStorage.set(namespace, key, state);

		},
		getMapState: function(namespace, key) {
			// var mapState;
			if (App.localStorage.get(namespace, key) === true) {
				return true;
			} else if (App.localStorage.get(namespace, key) === false) {
				return false;
			} else if (this.globalConfig().toJSON().defaultMapOpen === true) {
				return true;
			} else {
				return false;
			}

		},
		loading: function(show, view, force, delay = 500) {
			$('body').loadingOverlay(show, view, force, delay);
		},
		triggerResize:function(){
			// for older browser
			var evt = window.document.createEvent('UIEvents');
			evt.initUIEvent('resize', true, false, window, 0);
			window.dispatchEvent(evt);
			// newer browser
			$(window).resize();
		},
		isInViewport:function($obj, displayEntirely=false){
			var scrollTop = $(window).scrollTop();
			var viewportHeight = $(window).height();
			var scrollBottom = scrollTop + viewportHeight;
			var objTop = $obj.offset().top;
			var objBottom = objTop + $obj.height();
			if ( displayEntirely === true){
				return ((objBottom <= scrollBottom) && (objTop >= scrollTop));
			}
			return ((objTop > scrollTop) && (objTop < scrollBottom) || (objBottom > scrollTop) && (objBottom < scrollBottom));

		},
		// view can be single view or an array of view, and it can be a single jquery object or and array of jquery objects
		setupAutoComplete:function(view, compMoniker, options) {
			if ( this.globalConfig().toJSON().useAutoComplete === true) {
				if (!options) options = {} // in case there are no options passed from the views.
				_.extend(options, {
					compMoniker: compMoniker,
					searchFailCallback: (errorMessage) => {
						this.openAlert(errorMessage);
					}
				})
				var autoComplete = new AutoComplete(options);
				autoComplete.Build(view);
			}
		},
		subscribe:function(view,subscriberChannel){
			if ( view )
			{
				if (!view.subscribers){
					view.subscribers = {};
				}
				if ( !view.subscribers[subscriberChannel]){
					var channel = Radio.channel(subscriberChannel);
					view.subscribers[subscriberChannel] = channel;
				}
			}
		},
		broadcast:function(view,event){ // will support arguments... but it will become an array
			if ( view && view.subscribers ){
				for(var channel in view.subscribers) {
					//forward params other than view and event
					 view.subscribers[channel].trigger(event, [].slice.call(arguments,2));
				}
			}
		},
    logSuccess: function(message) {
      Logger.logSuccess(message)
    },
    logInfo: function(message) {
      Logger.logInfo(message)
    },
    logWarning: function(message) {
      Logger.logWarning(message)
    },
    logUserWarning: function(message) {
      Logger.logUserWarning(message)
    },
    logUserError: function(message) {
      Logger.logUserError(message)
    },
    logError: function(message) {
      Logger.logError(message)
    },
    logFault: function(message) {
      Logger.logFault(message)
    },
		logDebug: function(message) {
      Logger.logDebug(message)
    },
		htmlSafeString: function(unsafeString){
			let returnString = $('<p>').text(unsafeString).html();
			
			// Replacing all BR tags with correct HTML
			//Chrome no longer allows </br> tags. fixed to use the appropriate html tag (<br>)
			return returnString.replace('&lt;br /&gt;', '<br>').replace('&lt;br/&gt;', '<br>').replace(/&amp;/g, '&');
		},
		trimAttributes: function (node) {
			$.each(node.attributes, function() {
            let attrName = this.name || '';
            let attrValue = this.value || '';
            // remove attribute name start with "on", possible unsafe,
            // for example: onload, onerror...
            //
            // remvoe attribute value start with "javascript:" pseudo protocol, possible unsafe,
            // for example href="javascript:alert(1)"
            if (attrName.indexOf('on') == 0 || attrValue.indexOf('javascript:') == 0) {
              $(node).removeAttr(attrName);
            }
        });
		},
		removeScriptInjection: function (unsafeString) {
			let self = this;
			let safeStringHTML = $($.parseHTML(unsafeString));
			let safeString = '';
			safeStringHTML.each(function() {
				//cleanedNode = self.trimAttributes(eachNode);
				//safeString += cleanedNode.outerHTML;
				self.trimAttributes(this);

			});
			safeStringHTML.each(function() {
				safeString += this.outerHTML || this.nodeValue;
			});
			return safeString;
		},
		setLocalStorage: function(namespace, key, value){
			App.localStorage.set(namespace, key, value);

		},
		getLocalStorage: function(namespace, key) {
			return App.localStorage.get(namespace, key);
		},
		clearUserSpecificSessionStorage: function(sessionStorageToClearCivicsParam){
			//Clear the session storage for just the items that are user specific.

			//clear these session values for Civics
			let sessionStorageToClearCivics = sessionStorageToClearCivicsParam ? sessionStorageToClearCivicsParam :
								 ['CHOSEN_FEES', 'CHOSEN_INSTRUMENTS', 'CHOSEN_MIN_FEES', 'CHECKOUT_FEES', 'DISPLAY_FEES', 'FEES_CART', 'FILTER_ASSIGNMENTS_DATA', 'FILTER_MYDASH_DATA', 'FILTER_PROJECTS_DATA', 'FILTER_INSTRUMENTSLIST_DATA', 'USER_SESSION', 'WIZARD', 'CIVICS_DATA','FILTER_TASKS_DATA', 'SOCIAL_INFO'];
			
			let keepWizardSession = Utils.getCookie('keepWizardSession');
			if(keepWizardSession == 1 && !sessionStorageToClearCivicsParam){
				let wizardIndex = sessionStorageToClearCivics.indexOf('WIZARD');
				sessionStorageToClearCivics.splice(wizardIndex, 1); // do not clear the WIZARD session
			}
			
			$.each(sessionStorageToClearCivics, (index, sessionVar) => {
				App.sessionStorage.remove('CIVICS', sessionVar);
			});
		},
		clearUserSpecificLocalStorage: function(){
			//Clear the local storage for just the items that are user specific.
			let sessionStorageToClearCivics = ['MyTasksCardView_SortField','MyProjectsCardView_SortField','MyAssignmentsCardView_SortField','Instrument List Card View_SortField'];
			$.each(sessionStorageToClearCivics, (index, sessionVar) => {
				if( App.localStorage.get('CIVICS') )		//ensure CIVICS exists in local storage.
					App.localStorage.remove('CIVICS', sessionVar);
			});

			//clear these local values for Billing
			let sessionStorageToClearBilling = ['CURRENT_ACCOUNT_PROPERTY'];
			$.each(sessionStorageToClearBilling, (index, sessionVar) => {
				if( App.localStorage.get('BILLING') )		//ensure BILLING exists in local storage.
					App.localStorage.remove('BILLING', sessionVar);
			});

		}

	};
});
